/* ================================================================ */
// SIDEBAR CONTAINER | Sidebar.jsx
/* ================================================================ */
/* ========================================== */
// Imports
/* ========================================== */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// Material UI
import makeStyles from '@material-ui/styles/makeStyles';
// Constants
import {AlignmentTypes} from '@myglobe/core/dist/types';
/* ========================================== */
// Style Settings
/* ========================================== */
const useStyles = makeStyles(theme => ({
    root: {
        left: 0,
        zIndex: 1,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        transition: 'width 500ms cubic-bezier(0.215, 0.610, 0.355, 1.000)',
        background: theme.palette.background.default,
        '&.alignRight': {
            flexDirection: 'row-reverse'
        },
        '&.alignTop': {
            flexDirection: 'column'
        },
        '&.alignBottom': {
            flexDirection: 'column-reverse'
        }
    },
    navigation: {
        height: '100%',
        //width: '18em',
        display: 'flex',
        flexDirection: 'column',
        '&.fullSize': {
            width: '100%'
        }
    }
}));
/* ========================================== */
/**
 * Sidebar
 * -------
 * Menu and story panel with expansion handling
 *
 * @param {boolean} isExpanded initial expanded state
 */
/* ========================================== */
const Sidebar = (props) => {
    const classes = useStyles();
    const {children, logo, align, slug, isVisible} = props;
    console.log(slug)
    /*const {isAuthenticated, loginWithRedirect, logout, getTokenSilently} = useAuth0();
    const callAPI = async ()=>{
        try {
            var token = await getTokenSilently();
            console.debug('TOKEN', token);
            const response = await fetch('http://localhost:3000/graphql', {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type':'application/json',
                },
                method: 'POST',
                body: JSON.stringify({query: '{\n  allUsers {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n','variables': null})
            });
            const responseData = await response.json();
            console.debug(responseData);
        } catch(e) {
            console.error(e);
        }
    };
    */
    /* ======================== */
    // RENDER
    /* ======================== */
    const rootClasses = classNames(classes.root, {
        'alignLeft': align === AlignmentTypes.LEFT,
        'alignRight': align === AlignmentTypes.RIGHT,
        'alignTop': align === AlignmentTypes.TOP,
        //'expanded': expanded
    });
    //const slideDirection = (align === AlignmentTypes.LEFT || align === AlignmentTypes.RIGHT) ? align : align === AlignmentTypes.TOP ? 'down' : 'up';
    console.debug(`${Sidebar.displayName} | `, 'Render -', 'props:', props, 'logo:', logo, 'align:', align);
    return (
        <aside className={rootClasses}>
            {children}
            {//React.Children.map(children, child=>React.cloneElement(child, {slug, isVisible}))}
            }
        </aside>
    );
};
/* ======================== */
// PROPS
/* ======================== */
Sidebar.propTypes = {
    screen: PropTypes.shape({
        width: PropTypes.number.isRequired,
        height: PropTypes.number.isRequired
    }),
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    slug: PropTypes.string,
    align: PropTypes.oneOf(Object.values(AlignmentTypes)),
    isExpanded: PropTypes.bool
};
Sidebar.defaultProps = {
    isExpanded: false
};
Sidebar.displayName = 'Sidebar';
/* ========================================== */
// Export
/* ========================================== */
export default Sidebar;